/**
 * Colour gallery — when a shopper picks a variant, show that colour's photos: its front in the
 * lead arch and its own detail/back photos in the grid, hiding every other colour's photos.
 *
 * Contract (templates/product.liquid):
 *   script[data-colour-media-map] — JSON { variantId: [leadMediaId, colourHandle, styleHandle] }.
 *   [data-colour-media="<mediaId>"] — one lead tile per colour front; all but the selected are [hidden].
 *   [data-colour="<colour-handle>"] — grid photos that belong to one colour.
 *   [data-style] — "hoodie" or "crewneck" photos only show for that garment style; "any" shows for both.
 *   [data-product-gallery] — the scrolling gallery, reset to its start on mobile after a swap.
 *   Option inputs carry [data-variant-id] (or a select's chosen option does), as in s-variant-picker.
 */
const mapNode = document.querySelector('script[data-colour-media-map]');
let colourMap = {};
try {
  colourMap = JSON.parse(mapNode?.textContent || '{}');
} catch {
  colourMap = {};
}

function reveal(tile, show) {
  tile.hidden = !show;
  if (show) for (const img of tile.querySelectorAll('img[loading="lazy"]')) img.loading = 'eager';
}

function showColour(variantId) {
  const entry = colourMap[String(variantId)];
  if (!entry) return;
  const [mediaId, colour, style] = entry;
  let changed = false;
  for (const tile of document.querySelectorAll('[data-colour-media]')) {
    const show = tile.dataset.colourMedia === String(mediaId);
    if (tile.hidden === show) changed = true;
    reveal(tile, show);
  }
  if (colour) {
    for (const tile of document.querySelectorAll('[data-colour]')) {
      const tileStyle = tile.dataset.style || 'any';
      const styleOk = !style || tileStyle === 'any' || tileStyle === style;
      reveal(tile, tile.dataset.colour === colour && styleOk);
    }
  }
  if (changed) {
    const gallery = document.querySelector('[data-product-gallery]');
    if (gallery && gallery.scrollLeft !== 0) gallery.scrollTo({ left: 0, behavior: 'smooth' });
  }
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLElement)) return;
  const variantId = input.dataset?.variantId || input.selectedOptions?.[0]?.dataset?.variantId;
  if (variantId) showColour(variantId);
});
